// extracted by mini-css-extract-plugin
module.exports = {"link":"MediaPeopleLinks_link__00cFM"};